import { screenToWorld } from './camera.ts'
import { scene } from '../scene/store.ts'
import type { Point } from '../scene/types.ts'

/**
 * The viewport element's screen rect, cached. Reading it on every pointermove
 * would force layout between the transform writes a drag is already making.
 */
let el: HTMLElement | null = null
let rect: DOMRect | null = null

export function setViewportEl(next: HTMLElement | null): void {
  el = next
  rect = el?.getBoundingClientRect() ?? null
}

export function refreshViewportRect(): void {
  rect = el?.getBoundingClientRect() ?? null
}

export interface ClientPoint {
  clientX: number
  clientY: number
}

export function clientToScreen(e: ClientPoint): Point {
  if (!rect) refreshViewportRect()
  return { x: e.clientX - (rect?.left ?? 0), y: e.clientY - (rect?.top ?? 0) }
}

export function clientToWorld(e: ClientPoint): Point {
  return screenToWorld(scene.camera, clientToScreen(e))
}
